// IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы — поиск, настройки, dragDrop): вид SVG-графа — масштаб щипком (Ctrl / Meta + колесо, как AttrGraph.onGraphWheel:
// колесо и тачпад только прокручивают, масштаб — щипком и кнопками) и фокус: подсветка соседей при наведении (graph_hover_neighbors) и приглушение всего, кроме найденного поиском.
// Чистые функции (тест — tests/unit/schemeGraphV2Toolbar2.test.mjs); потребитель — AttrSchemeGraphV2. AttrGraph не менялся (у него камера sigma)
export const GRAPH_ZOOM_MIN = 0.2
export const GRAPH_ZOOM_MAX = 4

// масштаб вида по щипку: та же кривая, что у AttrGraph (exp(deltaY × 0,01), |deltaY| ≤ 40); deltaY > 0 — мельче. Пределы 0,2…4, около 1 (±0,02) — ровно 1
export function graphWheelZoom(cur, deltaY) {
    const c = Number(cur) > 0 && Number.isFinite(Number(cur)) ? Number(cur) : 1
    const d = Math.max(-40, Math.min(40, Number(deltaY) || 0))
    let v = c / Math.exp(d * 0.01)
    v = Math.max(GRAPH_ZOOM_MIN, Math.min(GRAPH_ZOOM_MAX, v))
    if (Math.abs(v - 1) < 0.02) v = 1
    return Math.round(v * 10000) / 10000
}

// размер svg с масштабом вида z: { w, h, k } (k — во сколько раз svg крупнее viewBox)
export function graphZoomBox(box, z) {
    const b = box && typeof box === 'object' ? box : { w: 0, h: 0, k: 1 }
    const f = Number(z) > 0 && Number.isFinite(Number(z)) ? Number(z) : 1
    if (f === 1) return b
    return { w: Math.max(1, Math.round((b.w || 0) * f)), h: Math.max(1, Math.round((b.h || 0) * f)), k: (b.k || 1) * f }
}

// фокус графа → { nodes: Set(id), edges: Set(key) } (остальное приглушается) | null — ничего не приглушать.
// Наведение главнее поиска (как у AttrGraph): узел под указателем — он, его соседи и их связи; связь под указателем — она и её концы (при hoverOn).
// Поиск (found — найденные узлы) без showAll — найденные узлы и связи, касающиеся их. edges: [{ key, from, to }]
export function graphFocus(edges, o = {}) {
    const list = Array.isArray(edges) ? edges : []
    if (o.hoverOn && o.hoverNode) {
        const id = o.hoverNode, nodes = new Set([id]), es = new Set()
        for (const e of list) if (e.from === id || e.to === id) { es.add(e.key); nodes.add(e.from); nodes.add(e.to) }
        return { nodes, edges: es }
    }
    if (o.hoverOn && o.hoverEdge && o.hoverEdge.key) {
        const e = o.hoverEdge
        return { nodes: new Set([e.from, e.to]), edges: new Set([e.key]) }
    }
    const found = o.found instanceof Set ? o.found : new Set(o.found || [])
    if (!found.size || o.showAll) return null
    const es = new Set()
    for (const e of list) if (found.has(e.from) || found.has(e.to)) es.add(e.key)
    return { nodes: new Set(found), edges: es }
}
